"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import SecurityServicesTabs from "@/components/pageTabs/securityServicesTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import AboutComp from "./components/about";
import AdvantageComp from "./components/advantages";
import WhyOneMindComponent from "./components/whyOnemind";
import OfferingsComp from "./components/offerings";
import ZtnaSecStack from "./components/ztnaStack";

const ZtnaVpnEdgeFirewall = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <SecurityServicesTabs />
        <Intro />
        <AdvantageComp />
      </PageLayout>
      <AboutComp />
      <PageLayout>
        <WhyOneMindComponent />
      </PageLayout>
      <OfferingsComp />
      <PageLayout showContactForm>
        <ZtnaSecStack />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default ZtnaVpnEdgeFirewall;
